module.exports = __webpack_public_path__ + "static/media/etiqa.b989b3c8.png";